// Artwork exported from the Figma frame "Friends / Mobile — Modal" (4244:41053) on the PAVEL
// DRAFT page, via the Dev Mode asset server.
//
// Unlike the inventory icons these are stored without their intrinsic `width`/`height`: SVGO's
// `removeViewBox` drops the viewBox whenever it agrees with those attributes, and an SVGR icon
// with no viewBox stops scaling - it paints at its export size wherever it is put, so on a
// narrower phone (scale < 1) the paths get clipped by the smaller frame. Keeping the viewBox is
// what lets the row scale with the panel.
//
// The level badge and the status dots are plain circles in the design and are drawn in code.
import AvatarPlaceholderPng from './avatar-placeholder.png';
import IconRemoveFriendSvg from './icon-remove-friend.svg';
import IconSearchSvg from './icon-search.svg';
import IconSendGiftSvg from './icon-send-gift.svg';

export { AvatarPlaceholderPng, IconRemoveFriendSvg, IconSearchSvg, IconSendGiftSvg };
